import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import moment from 'moment';
import { inspectorSelectors } from 'redux/app/vessel/inspector';
import { IStore } from 'redux/store';
import { vesselSelectors } from 'redux/app/vessel';

type OwnProps = {
	vesselId: string;
    selectedDate?: string;
};
type EngineLogTeekayCoverPageProps = PropsFromRedux & OwnProps;
function EngineLogTeekayCoverPage(props: EngineLogTeekayCoverPageProps) {
    const { vesselInfo, selectedDate } = props;
    const engineLogData = {
        firstPage: {
            mt: vesselInfo?.vesselName ?? '',
            callSign: vesselInfo?.callSign ?? '',
            officialNo: vesselInfo?.imoNumber ?? '',
            periodFrom:
                (selectedDate && moment(selectedDate).format('DD-MM-yyyy')) ??
                '',
            periodTo:
                (selectedDate && moment(selectedDate).format('DD-MM-yyyy')) ??
                '',
        },
    };

    const { firstPage } = engineLogData;
    const { mt, callSign, periodFrom, periodTo } = firstPage;
    return (
        <>
            {/* First page */}
            <div className="flex flex-col justify-between py-4 px-8 mb-2 print-page-break">
                <div className="font-medium text-center text-xl my-24 mx-0">
                    <h2 className="uppercase text-2xl">ENGINE ROOM LOG BOOK</h2>
                </div>
                <div className="flex justify-center mt-8 mb-32">
                    <div className="w-2/3 mt-2.5">
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Vessel Name:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                {mt}
                            </p>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Call Sign:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                {callSign}
                            </p>
                        </div>
                        <div
                            className="flex justify-between items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <div
                                style={{ width: '54%' }}
                                className="flex items-center  mb-2"
                            >
                                <p className="mr-2 min-w-fit">Period From :</p>
                                <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                                    {periodFrom}
                                </p>
                            </div>
                            <div
                                style={{ width: '45%' }}
                                className="flex items-center mb-2"
                            >
                                <p className="mr-2 min-w-fit">To :</p>
                                <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                                    {periodTo}
                                </p>
                            </div>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Working language of the ship:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                English
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            {/* Second page */}
            <div className="flex flex-col justify-between py-4 pt-0 px-8 mb-2 text-left print:pt-8">
                <p className="print:pb-2">
                    <strong>Note:</strong> Duty Engineer completes this logbook under supervision of Chief Engineer
                </p>
                <p className='my-2'>Entries for the remarks section</p>

                <ol className="list-alpha list-alpha-lower ml-4">
                    <li>
                        <p>Name and time of port's</p>
                        <ul
                            className='list-disc ml-4'
                        >
                            <li className="my-2 mx-0">
                                Arrival
                            </li>
                            <li className="my-2 mx-0">
                                Departure
                            </li>
                        </ul>
                    </li>
                    <li>
                        <p>Time of main engine</p>
                        <ul
                            className='list-disc ml-4'
                        >
                            <li className="my-2 mx-0">
                                Preparation
                            </li>
                            <li className="my-2 mx-0">
                                Standby
                            </li>
                            <li className="my-2 mx-0">
                                Ready
                            </li>
                            <li className="my-2 mx-0">
                                Finished with engines
                            </li>
                        </ul>
                    </li>
                    <li>
                        <p>Time of starting and stopping</p>
                        <ul
                            className='list-disc ml-4'
                        >
                            <li className="my-2 mx-0">
                                Auxiliary engines
                            </li>
                            <li className="my-2 mx-0">
                                Auxiliary machinery and operation log for additional power requirements during ballast exchange operations
                            </li>
                            <li className="my-2 mx-0">
                                IG plant
                            </li>
                            <li className="my-2 mx-0">
                                Cargo pumps
                            </li>
                            <li className="my-2 mx-0">
                                Ballast pumps
                            </li>
                        </ul>
                    </li>
                    <li>
                        <p>Time of filling and changing of fuel oil tanks</p>
                    </li>
                    <li>
                        <p>Time of location of fuel change over</p>
                    </li>
                    <li>
                        <p>Time of bunkering</p>
                    </li>
                    <li>
                        <p>Any defect, fault or breakdown in the main and auxiliary machinery and measures taken to rectify</p>
                    </li>
                    <li>
                        <p>Important maintenance work on the main and auxiliary machinery including</p>
                        <ul
                            className='list-disc ml-4'
                        >
                            <li className="my-2 mx-0">
                                Cleaning of the tanks and scavenge spaces as applicable
                            </li>
                            <li className="my-2 mx-0">
                                Engine room crew's maintenance work on deck machinery
                            </li>
                        </ul>
                    </li>
                    <li>
                        <p>Sampling and testing of</p>
                        <ul
                            className='list-disc ml-4'
                        >
                            <li className="my-2 mx-0">
                                Boiler water
                            </li>
                            <li className="my-2 mx-0">
                                Lube and fuel oils
                            </li>
                        </ul>
                    </li>
                    <li>
                        <p>Time of</p>
                        <ul
                            className='list-disc ml-4'
                        >
                            <li className="my-2 mx-0">
                                Testing of the emergency power supply
                            </li>
                            <li className="my-2 mx-0">
                                Running of the emergency fire pump and steering gear
                            </li>
                        </ul>
                    </li>
                    <li>
                        <p>Testing and replacement of any part in the fire or smoke detection system and the firefighting system.</p>
                    </li>
                    <li>
                        <p>Times of UMS and manned engine operations.</p>
                    </li>
                    <li>
                        <p>All UMS alarms, including any corrective measure taken.</p>
                    </li>
                    <li>
                        <p>Record of Critical Alarms off scanned and reset time if any.</p>
                    </li>
                    <li>
                        <p>Marpol equipment (Incinerator and OWs) start and stop time.</p>
                    </li>
                    <li>
                        <p>Changeover from engine room to bridge control and vice versa.</p>
                    </li>
                    <li>
                        <p>Log the temperature of each refrigerated unit twice per day.</p>
                    </li>
                    <li>
                        <p>Record of any incident or accident in the engine room.</p>
                    </li>
                    <li>
                        <p>Completion of relevant procedures, forms and checklists.</p>
                    </li>
                </ol>
            </div>
            {/* Third page */}
            <div className="flex flex-col justify-between py-4 pt-0 px-8 mb-2 text-left print:pt-8">
                <h2 className="uppercase text-2xl font-semibold text-center print:pb-2">
                    INSTRUCTIONS FOR COMPLETION OF THE ENGINE ROOM LOGBOOK
                </h2>

                <ol className="list-decimal ml-4">
                    <li className="my-2 mx-0">
                        The Logbook shall be kept by the Chief Engineer and
                        written up by the Duty Engineer.
                    </li>
                    <li className="my-2 mx-0">
                        When operating in unmanned condition the Logbook will be completed at least twice daily, when watchkeeping the Logbook will be completed at eight-hour intervals.
                    </li>
                    <li className="my-2 mx-0">
                        The Logbook should be completed in ink and entries in pencil are prohibited.
                    </li>
                    <li className="my-2 mx-0">
                        If a wrong entry is made, one line is to be drawn through that part and the correct entry shall be inserted and initialed by the Watchkeeper. The use of correcting fluid or erasers is not acceptable.
                    </li>
                    <li className="my-2 mx-0">
                        All times of starting and stopping auxiliary machinery is to be logged in the "Remarks" section.
                    </li>
                    <li className="my-2 mx-0">
                        The time and description of any unusual occurrence is to be logged, together with details of any necessary action.
                    </li>
                    <li className="my-2 mx-0">
                        Details of major maintenance work carried out or in progress are to be entered in the "Remarks" section.
                    </li>
                    <li className="my-2 mx-0">
                        All alarms that occur when the engine room is unmanned are to be recorded and the necessary action logged. All times of manned and unmanned operation are to be clearly indicated. The times of routine inspections are to be logged.
                    </li>
                    <li className="my-2 mx-0">
                        Details of Emergency Drills are to be recorded, together with the testing of all Emergency Equipment.
                    </li>
                    <li className="my-2 mx-0">
                        A description of the engines and boilers and any other relevant particulars are to be entered at the front of the Logbook.
                    </li>
                    <li className="my-2 mx-0">
                        The time of routine testing of equipment prior to manoeuvring is to be recorded.
                    </li>
                    <li className="my-2 mx-0">
                        The completed Logbook shall be retained on board for at least three years.
                    </li>
                </ol>
            </div>
        </>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const inspectorStore = inspectorSelectors._getStore(store);
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);	
    const dateRange = inspectorSelectors.getDateRange(inspectorStore);

    return {
        vesselInfo,
        dateRange,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(EngineLogTeekayCoverPage);
